import { NestedRoutes } from "../../../app/routes.types";
import { Offices } from ".";
import OfficesIcon from "../../../assets/Admin/Offices";
import { EditOffice } from "./EditOffice";
import { AddOffice } from "./AddOffice";
import { AddTeamMember } from "./AddTeamMember";
import { AddRoom } from "./AddRoom";
import { EditRoom } from "./EditRoom";
import { Api } from "../../../services/api";
import { UserPermissions } from "../../../enums";

export const OfficesRoutes: NestedRoutes = {
  icon: OfficesIcon,
  name: "Offices",
  path: "offices",
  component: Offices,
  permissions: [UserPermissions.OfficeViewList],
  children: [
    {
      name: "Add Office",
      path: "add",
      component: AddOffice,
      permissions: [UserPermissions.OfficeAddOffice],
    },
    {
      path: ":officeId",
      getName: async (params: Record<string, string>) => {
        return await Api.offices.getOffice(params.officeId).then(res => {
          return res.data.name;
        });
      },
      permissions: [
        UserPermissions.OfficeViewDetails,
        UserPermissions.OfficeManageDetails,
      ],
      children: [
        {
          name: "Edit",
          path: "edit",
          component: EditOffice,
          permissions: [
            UserPermissions.OfficeViewDetails,
            UserPermissions.OfficeManageDetails,
          ],
        },
        {
          name: "Add Members",
          path: "addMember",
          component: AddTeamMember,
          permissions: [UserPermissions.OfficeManageMembers],
        },
        {
          name: "Add Room",
          path: "addRoom",
          component: AddRoom,
          permissions: [UserPermissions.OfficeManageRooms],
        },
        {
          name: "Edit Room",
          path: "editRoom/:roomId",
          component: EditRoom,
          permissions: [
            UserPermissions.OfficeViewRooms,
            UserPermissions.OfficeManageRooms,
          ],
        },
      ],
    },
  ],
};
